import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import getOr from 'lodash/fp/getOr';
import findIndex from 'lodash/findIndex';
import { LocalStorage } from "../models/LocalStorage";
import { Auth } from "../models/auth";
import Env from "../environments";
// import { logoutApi } from "./api";

export class FireBase {
  static _hasFirebase;

  static getHasFirebase() {
    return this._hasFirebase;
  }
  static setHasFirebase(value) {
    this._hasFirebase = value;
  }

  static setUpFirebase() {
    if (this.getHasFirebase()) return;
    const firebaseConfig = {
      apiKey: Env.DUTY_CAST_EXTENSION_FIREBASE_API_KEY,
      authDomain: Env.DUTY_CAST_EXTENSION_FIREBASE_AUTH_DOMAIN,
      databaseURL: Env.DUTY_CAST_EXTENSION_FIREBASE_DATABASE_URL,
      projectId: Env.DUTY_CAST_EXTENSION_FIREBASE_PROJECT_ID,
      storageBucket: Env.DUTY_CAST_EXTENSION_FIREBASE_STORAGE_BUCKET,
      messagingSenderId: Env.DUTY_CAST_EXTENSION_FIREBASE_MESSAGING_SENDER_ID,
    };
    firebase.initializeApp(firebaseConfig);
    this.setHasFirebase(true);
  }

  static getUpdatedOrder = (orderCode, onSuccess) => {
    this.setUpFirebase();
    try {
      firebase.database().ref(`${Env.DUTY_CAST_EXTENSION_FIREBASE_REF || ""}/orders/${orderCode}`).on('value', snapshot => {
        const data = snapshot.val();
        typeof (onSuccess) === "function" && onSuccess(data);
      })
    } catch (error) {
      console.error(error)
    }
  }


  static stopGetUpdateOrder = (orderCode, ref) => {
    this.setUpFirebase();
    firebase.database().ref(`${Env.DUTY_CAST_EXTENSION_FIREBASE_REF || ""}/orders/${orderCode}/updated_at`).off('value', ref);
  }

  static getUpdatedUser = (onSuccess) => {
    this.setUpFirebase();
    try {
      firebase.database().ref(`${Env.DUTY_CAST_EXTENSION_FIREBASE_REF || ""}/users/${LocalStorage.getSub()}/updated_at`).on('value', snapshot => {
        const data = snapshot.val();
        typeof (onSuccess) === "function" && onSuccess(data);
      })
    } catch (error) {
      console.error(error)
    }
  }

  static signInWithGoogle = (onSuccess, onError) => {
    this.setUpFirebase();
    const provider = new firebase.auth.GoogleAuthProvider();
    firebase.auth().signInWithPopup(provider).then(function (result) {
      const user = result.user;
      typeof (onSuccess) === "function" && onSuccess(user);
    }).catch(function (error) {
      typeof (onError) === "function" && onError(error);
    });
  }

  static signInWithFacebook = (onSuccess, onError) => {
    this.setUpFirebase();
    const provider = new firebase.auth.FacebookAuthProvider();
    firebase.auth().signInWithPopup(provider).then(function (result) {
      const user = result.user;
      typeof (onSuccess) === "function" && onSuccess(user);
    }).catch(function (error) {
      typeof (onError) === "function" && onError(error);
    });
  }

  static signInWithTwitter = (onSuccess, onError) => {
    this.setUpFirebase();
    const provider = new firebase.auth.TwitterAuthProvider();
    firebase.auth().signInWithPopup(provider).then(function (result) {
      const user = result.user;
      typeof (onSuccess) === "function" && onSuccess(user);
    }).catch(function (error) {
      typeof (onError) === "function" && onError(error);
    });
  }

  static getUserInfo = (onSuccess, onError) => {
    this.setUpFirebase();
    firebase.auth().onAuthStateChanged(function (user) {
      try {
        if (user) {
          typeof (onSuccess) === "function" && onSuccess(user);
        } else {
          typeof (onError) === "function" && onError();
        }
      } catch (error) {
        typeof (onError) === "function" && onError(error);
      }
    });
  }

  static getCurrentUser = () => {
    this.setUpFirebase();
    return firebase.auth().currentUser;
  }

  static updateUserInfo = (data, onSuccess, onError) => {
    this.setUpFirebase();
    const user = this.getCurrentUser();
    if (user) {
      if (data.password) {
        this.updatePassword(user, data.password, function () {
          const noPassword = {
            ...data
          };
          delete data["password"];
          user.updateProfile(noPassword).then(function () {
            typeof (onSuccess) === "function" && onSuccess();
          }).catch(function (error) {
            FireBase.errorReloginCheck(error)
            typeof (onError) === "function" && onError(error);
          });
        }, function (error) {
          FireBase.signOut();
          typeof (onError) === "function" && onError(error);
        })
      } else {
        user.updateProfile(data).then(function () {
          typeof (onSuccess) === "function" && onSuccess();
        }).catch(function (error) {
          FireBase.errorReloginCheck(error);
          typeof (onError) === "function" && onError(error);
        });
      }
    } else {
      typeof (onError) === "function" && onError();
    }
  }

  static updatePassword = (user, password, onSuccess, onError) => {
    this.setUpFirebase();
    try {
      user.updatePassword(password).then(function () {
        typeof (onSuccess) === "function" && onSuccess();
      }).catch(function (error) {
        FireBase.errorReloginCheck(error);
        typeof (onError) === "function" && onError(error);
      });
    } catch (error) {
      typeof (onError) === "function" && onError(error);
    }
  }

  static logoutLocal = (onSuccess, onError, cb, isCallLogout = true) => {
    this.setUpFirebase();
    LocalStorage.logout(cb, isCallLogout);
    try {
      firebase.auth().signOut().then(function () {
        try {
          typeof (onSuccess) === "function" && onSuccess();
        } catch (error) {
          console.error(error);
          typeof (onError) === "function" && onError(error);
        }
      }).catch(function (error) {
        console.error(error);
        typeof (onError) === "function" && onError(error);
      });
    } catch (error) {
      console.error(error);
    }
  }

  static signOut = (onSuccess, onError, cb, isCallLogout = true) => {
    this.logoutLocal(onSuccess, onError, cb, isCallLogout);
    // logoutApi(function () {
    //   logoutLocal(onSuccess, onError, cb);
    // }, function (error) {
    //   logoutLocal(onSuccess, onError, cb);
    //   console.error(error);
    // });
  }

  static setupRecaptcha = () => {
    this.setUpFirebase();
    if (!window.recaptchaVerifier) {
      window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('recaptcha', {
        'size': 'invisible',
        'callback': function (response) {
        }
      });
      return window.recaptchaVerifier;
    } else {
      return window.recaptchaVerifier;
    }
  }

  static setupPhone = (phoneNumber, onSuccess, onError) => {
    this.setUpFirebase();
    const appVerifier = this.setupRecaptcha();
    firebase.auth().signInWithPhoneNumber(phoneNumber, appVerifier)
      .then(function (confirmationResult) {
        typeof (onSuccess) === "function" && onSuccess(confirmationResult);
      }).catch(function (error) {
        typeof (onError) === "function" && onError(error);
      });
  }

  static confirmPhone = (code, isLogin = true, onSuccess, onError) => {
    this.setUpFirebase();
    try {
      if (!isLogin) {
        return firebase.auth.PhoneAuthProvider.credential(window.confirmationResult.verificationId, code);
      } else {
        window.confirmationResult.confirm(code).then(function (result) {
          typeof (onSuccess) === "function" && onSuccess(result.user);
        }).catch(function (error) {
          FireBase.errorReloginCheck(error);
          typeof (onError) === "function" && onError(error);
        });
      }
    } catch (error) {
      typeof (onError) === "function" && onError(error);
    }
  }

  static addEmail = (email, password, onSuccess, onError) => {
    this.setUpFirebase();
    var credential = firebase.auth.EmailAuthProvider.credential(email, password);
    this.linkWithCredential(credential, onSuccess, onError);
  }

  static linkWithCredential = (credential, onSuccess, onError) => {
    this.setUpFirebase();
    firebase.auth().currentUser.linkWithCredential(credential)
      .then(function (usercred) {
        typeof (onSuccess) === "function" && onSuccess(usercred.user);
      }).catch(function (error) {
        typeof (onError) === "function" && onError(error);
      });
  }

  static PROVIDERS = {
    PHONE: "phone",
    EMAIL: "password",
    GOOGLE: "google.com",
    FACEBOOK: "facebook.com"
  }

  static checkProvider = (user, provider) => {
    const providerData = getOr([], "providerData")(user);
    return findIndex(providerData, { providerId: provider }) !== -1;
  }

  static createUserWithEmailPassword = (email, password, onSuccess, onError) => {
    this.setUpFirebase();
    firebase.auth().createUserWithEmailAndPassword(email, password).then(function (data) {
      typeof (onSuccess) === "function" && onSuccess(data.user);
    }).catch(function (error) {
      typeof (onError) === "function" && onError(error);
    });
  }

  static loginWithEmailPassword = (email, password, onSuccess, onError) => {
    this.setUpFirebase();
    firebase.auth().signInWithEmailAndPassword(email, password).then(function (data) {
      typeof (onSuccess) === "function" && onSuccess(data.user);
    }).catch(function (error) {
      typeof (onError) === "function" && onError(error);
    });
  }

  static resetPassword = (email, onSuccess, onError) => {
    this.setUpFirebase();
    var actionCodeSettings = {
      url: window.location.href,
      handleCodeInApp: false
    };
    firebase.auth().sendPasswordResetEmail(email, actionCodeSettings).then(function (data) {
      typeof (onSuccess) === "function" && onSuccess();
    }).catch(function (error) {
      FireBase.errorReloginCheck(error);
      typeof (onError) === "function" && onError(error);
    });
  }

  static changePassword = (password, onSuccess, onError) => {
    this.getCurrentUser().updatePassword(password).then(function () {
      typeof (onSuccess) === "function" && onSuccess();
    }).catch(function (error) {
      FireBase.errorReloginCheck(error);
      typeof (onError) === "function" && onError(error);
    });
  }

  static errorReloginCheck = (error) => {
    if (error && error.code === 'auth/requires-recent-login') {
      setTimeout(() => {
        FireBase.signOut(undefined, undefined, Auth.callBackLogin());
      }, 1000);
    }
  }
}

window.userInfo = function () {
  return FireBase.getCurrentUser();
};

window.signOut = FireBase.signOut;